import React from 'react';
import {
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection } from '../../components/footer/ContentSection';

export const HipaaPage: React.FC = () => {
  const theme = useTheme();

  return (
    <PageLayout
      title="HIPAA Compliance"
      subtitle="Learn about our commitment to protecting your health information and HIPAA compliance."
    >
      <ContentSection>
        <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            What is HIPAA?
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            The Health Insurance Portability and Accountability Act (HIPAA) is a federal law that protects the privacy and security of your health information. We are committed to complying with HIPAA requirements.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            How We Protect Your Information
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            We implement administrative, physical, and technical safeguards to protect your health information. This includes encryption, access controls, and regular security assessments.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Your Rights Under HIPAA
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            You have the right to access your health information, request corrections, and receive a copy of your records. You also have the right to request restrictions on how we use or disclose your information.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Business Associate Agreements
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            We enter into business associate agreements with all third-party vendors who may have access to your health information to ensure they also comply with HIPAA requirements.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Breach Notification
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            In the unlikely event of a breach of your health information, we will notify you and the appropriate authorities as required by HIPAA regulations.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            If you have any questions about our HIPAA compliance or your health information rights, please contact us at privacy@careva.ai.
          </Typography>
        </Box>
      </ContentSection>
    </PageLayout>
  );
};
